import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const SwitchOff: BleskIcon = forwardRef(function SwitchOff(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        d="M7.5 7.5C9.985 7.5 12 9.515 12 12V12C12 14.485 9.985 16.5 7.5 16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 16.5H7.5C5.015 16.5 3 14.485 3 12V12C3 9.515 5.015 7.5 7.5 7.5H16.5C18.985 7.5 21 9.515 21 12V12C21 14.485 18.985 16.5 16.5 16.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
